import {
  Injectable,
  computed,
  inject,
  signal
} from '@angular/core';
import { Observable, switchMap, tap } from 'rxjs';

import { CheckedUser } from '../nickname-bonus/nickname-bonus.entity';

import { UserBonusService } from './user-bonus.service';
import { BonusCodesService } from './bonus-codes.service';
import { BonusCode } from './bonus-codes.entity';
import { UserBonusApiResponse } from './user-bonus.entity';

@Injectable({
  providedIn: 'root'
})
export class UserBonusState {
  private readonly userBonusService = inject(UserBonusService);
  private readonly bonusCodeService = inject(BonusCodesService);

  public readonly maxBonusUsd = signal<number>(0);
  public readonly maxBonusPct = signal<number>(0);
  public readonly totalBonusPct = signal<number>(0);
  public readonly totalBonusUsd = signal<number>(0);
  public readonly nickname = signal<CheckedUser|null>(null);
  public readonly referralBonus = signal<number>(0);
  public readonly secretCode = signal<BonusCode|null>(null);

  public readonly bonuses = computed(() => {
    const nickname = this.nickname();
    const referralBonus = this.referralBonus();
    const secretCode = this.secretCode();

    return {
      nickname: nickname?.bonus?.depositBonusPct,
      refCode: referralBonus,
      secretCode: secretCode?.bonusAmountPct
    };
  });

  loadUserBonuses(): Observable<UserBonusApiResponse.PaymentBonuses> {
    return this.userBonusService.getUserBonuses().pipe(
      tap((response) => {
        this.maxBonusPct.set(response.maxBonusPct);
        this.totalBonusUsd.set(response.totalBonusUsd);
        this.totalBonusPct.set(response.totalBonusPct);
        this.maxBonusUsd.set(response.maxBonusUsd);
        this.maxBonusPct.set(response.maxBonusPct);
        this.nickname.set(response.nickname);
        this.referralBonus.set(response.referralBonus);
        this.secretCode.set(response.secretCode);
      })
    );
  }

  applySecretCode(bonusCode: string) {
    return this.bonusCodeService.useBonusCode(bonusCode)
      .pipe( switchMap(() => this.loadUserBonuses()) );
  }
}